export default "__VITE_ASSET__CXi237Jr__"